import styled from 'styled-components';
import { dsColors, FlexBox } from '@Backlot-Cars/archie';

export const OktaWrapper = styled.div`
	display: flex;
	justify-content: center;
	height: 100%;
	width: 100%;

	/* override okta styles to match openlane */
	#okta-sign-in.auth-container.main-container {
		height: 100%;
		width: 100%;
		margin: 0;
		border: none;
		box-shadow: none;
		font-family: var(--fontFamily, sans-serif);

		.okta-form-title {
			font-size: 1.5rem !important;
			font-weight: 600 !important;
		}

		.o-form-head {
			display: none !important; /* hide tittle */
		}

		.okta-sign-in-header {
			display: none !important; /* hide image logo */
		}

		.auth-content {
			padding: 0 !important; /* this class add padding dynamically so here we just override it */
			max-width: unset !important;
		}

		.button-primary {
			background: var(--color-action-primary-surface);
			border: 1px solid var(--color-action-primary-surface);
			border-radius: 8px !important;
			border-width: 0 !important;
			font-weight: bold;
			height: 50px;
		}

		/* customize inputs */
		.o-form-input-name-password,
		.o-form-input-name-username {
			border-radius: var(--inputBorderRadius);
			height: unset;

			input {
				border-radius: 8px !important;
				border-radius: var(--inputBorderRadius);
				border-color: var(--color-form-border-default);
				padding: 10px;
				font-size: var(--font-content-default);
				font-weight: var(--fontWeightRegular);
				line-height: 1.5;
				height: var(--inputHeight);

				&:focus-visible,
				&.focus {
					box-shadow: 0px 0px 2px 2px ${dsColors.colorEffects.focus};
				}
			}
		}
	}
`;

export const LoaderWrapper = styled(FlexBox).attrs({
	flexDirection: 'column',
	width: '100%',
	minHeight: '335px',
	justifyContent: 'center',
	alignItems: 'center',
	backgroundColor: 'secondary',
})``;
